/**
 * Marketing route — re-renders the existing frontend/app/page.tsx
 * verbatim. Since that file is already "use client" and imports go
 * through the @/lib/compat shims (Phase 0), the Vite bundle resolves
 * everything without a single source edit on the production tree.
 */
import HomeMarketing from "@/app/page";

export function MarketingPage() {
  return <HomeMarketing />;
}
